export const setCookie = (key, value, permanent = false, shouldExpire = false) => {
  let expires = '';
  if (shouldExpire) {
    // Set expiry date to the past to delete the cookie
    expires = '; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  } else if (permanent) {
    // Set expiry date to 10 years from now
    const tenYearsInFuture = new Date(Date.now() + 10 * 365 * 24 * 60 * 60 * 1000).toUTCString();
    expires = `; expires=${tenYearsInFuture}`;
  } else {
    // Set expiry date to 24 hours from now
    expires = `; expires=${new Date(Date.now() + 86400000).toUTCString()}`;
  }

  if (process.env.NEXT_PUBLIC_HOST_URL === 'http://localhost:3000') {
    document.cookie = `${key}=${value}${expires}; path=/; SameSite=Strict;`;
  } else {
    document.cookie = `${key}=${value}${expires}; path=/; domain=quattr.com; SameSite=Strict; Secure`;
  }
};
